/**
 * Check if an address is the zero address, null, or undefined.
 *
 * @param address - The address to check, which can be a valid address, null, or undefined.
 * @returns True if the address is zero, null, or undefined; otherwise, false.
 */
export const isZeroAddressOrUnset = (
  address: string | null | undefined
): address is '0x0000000000000000000000000000000000000000' | null | undefined =>
  address == null ||
  address == undefined ||
  address === '0x0000000000000000000000000000000000000000'
